export default __webpack_public_path__ + "static/media/Pingoo-giff-4.3319e23d.mp4";